import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { AppSettings } from '../core/appSettings';
import { DEFAULT_LANGUAGE } from './language.service';

@Injectable({ providedIn: 'root' })
export class TranslationService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang?: string): Observable<Record<string, string>> {
    const language = lang || DEFAULT_LANGUAGE;
    const url = `${AppSettings.TRANSLATION_SERVICE_URL}/eys/${language}`;

    return this.http.get<Record<string, string>>(url);
  }
}
